import { render, staticRenderFns } from "./AC-ArchivesView.vue?vue&type=template&id=bfc696b4&scoped=true&"
import script from "./AC-ArchivesView.vue?vue&type=script&lang=js&"
export * from "./AC-ArchivesView.vue?vue&type=script&lang=js&"
import style0 from "./AC-ArchivesView.vue?vue&type=style&index=0&id=bfc696b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc696b4",
  null
  
)

export default component.exports